import { render, staticRenderFns } from "./Game6-8.vue?vue&type=template&id=244ce99a&scoped=true&"
import script from "./Game6-8.vue?vue&type=script&lang=js&"
export * from "./Game6-8.vue?vue&type=script&lang=js&"
import style0 from "./Game6-8.vue?vue&type=style&index=0&id=244ce99a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ce99a",
  null
  
)

export default component.exports